import Localizer from "@Scripts/Common/Localizer";
import CookieHelper from "@Scripts/Infrastructure/CookieHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import NotificationHelper from "@Scripts/Infrastructure/NotificationHelper";
import Vue from "vue";
import Component from "vue-class-component";

@Component({ name: "NotificationToast" })
export default class NotificationToast extends Vue {
    public localizer: any = Localizer;
    public isNotificationToast: boolean = false;

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        const self = this;

        setTimeout(function () {
            if (!CookieHelper.getCookie("ntf")) {
                if (NotificationHelper.checkPermession()) {
                    self.isNotificationToast = true;
                }
            }
        }, 5000);
    }

    public setDenied() {
        this.setCustomCookie("false");
    }

    public setGranted() {
        this.setCustomCookie("true");
        NotificationHelper.init();
    }

    public setCustomCookie(value: string) {
        CookieHelper.setCookie("ntf", value, 182);
        this.isNotificationToast = false;
    }
};